const createPaymentIntent = (reader, server) => {
  if (reader === 'wpe') {
    return `/**
     * Create a payment intent on the backend
     */
    @POST(${server === 'php' ? '"create.php"' : '"create_payment_intent"'})
    fun createPaymentIntent(): Call<ServerPaymentIntent>`;
  }
};

export default ({keys, reader, server}) => `
package com.stripe.example

import com.stripe.example.ConnectionToken
import com.stripe.example.ServerPaymentIntent
import retrofit2.Call
import retrofit2.http.Field
import retrofit2.http.FormUrlEncoded
import retrofit2.http.POST

/**
 * The 'BackendService' interface handles the two simple calls we need to make to our backend.
 * This represents YOUR backend, so feel free to change the routes accordingly.
 */
interface BackendService {

    /**
     * Get a connection token string from the backend
     */
    @POST(${server === 'php' ? '"token.php"' : '"connection_token"'})
    fun getConnectionToken(): Call<ConnectionToken>

    ${createPaymentIntent(reader, server)}

    /**
     * Capture a specific payment intent on our backend
     */
    @FormUrlEncoded
    @POST(${server === 'php' ? '"capture.php"' : '"capture_payment_intent"'})
    fun capturePaymentIntent(@Field("payment_intent_id") id: String): Call<Void>
}
`;
